import { Component, input } from '@angular/core';
import { SynIconComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-icon',
  template: `<div class="flex-row justify-center">
    <!-- The additional <div> ensures vertical alignment of the icon. -->
    <!-- See the invitations table where text and icon need to be aligned. -->
    <syn-icon [name]="icon()"></syn-icon>
  </div>`,
  styles: [
    `
      syn-icon {
        font-size: var(--syn-font-size-large);
      }
    `,
  ],
  imports: [SynIconComponent],
})
export class IconComponent {
  icon = input('');
}
